import $ from 'jquery';

import { bindClearButton, bindSearchDropdowns } from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  dropdowns: $(`.search-box-field`),
  clearButton: $(`#clear-button`),
};
const searchField = $(`.select2-search__field`);

export default class ProductManagement {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.searchField = searchField;
    this.bindElements();
    this.handleMultiplesWithNewLines();
  }

  static init() {
    if ($(`.product_management.show`).length === 0) {
      return undefined;
    }

    return new ProductManagement();
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
    bindClearButton(this.searchFormElements);
  }

  // select2 uses a search type input element, which automatically converts
  // newline characters into spaces
  // If a user is copy/pasting newline-separated values, we must munge the pasted
  // data so it can be properly tokenized by select2
  handleMultiplesWithNewLines() {
    this.searchField.on(`paste`, function(e) {
    // get the raw pasted text
      const data = e.originalEvent.clipboardData.getData(`Text`);
      // replace newlines by spaces and add to content
      $(this).val($(this).val() + data.replace(/\n/g, ` `));

      // prevent normal paste behaviour
      return false;
    });
  }
}
